// import hooks
import { isNil, omit } from 'ramda';

// import utils
import dayjs from 'dayjs';

// import types
import {
  AdminFunction,
  FunctionFlag,
  FunctionFlags,
  FunctionFormValues
} from '../AdminFunctions.types';

export type FunctionGroupsResponse = {
  functionId: number;
  description: string;
};

export const convertFlagsObjectToArray = (flags: FunctionFlags): string[] => {
  return Object.keys(flags).filter((key) => flags[key] === true);
};

export const convertPayloadForSave = (
  data: FunctionFormValues
): AdminFunction => ({
  ...omit(['convertedFlags'], data),
  valid: {
    from: dayjs(data.valid.from).startOf('day').toISOString(),
    to: dayjs(data.valid.to).startOf('day').toISOString()
  },
  flags: convertFlagsObjectToArray(data.convertedFlags)
});

export const convertResponseToOptions = (
  response: FunctionGroupsResponse[] | undefined
) =>
  response
    ? response.map((data) => {
        return {
          label: data.description,
          value: data.functionId
        };
      })
    : [];

export const hasFlag = (
  currentFlag: FunctionFlag,
  rowData?: FunctionFormValues
) => {
  if (!isNil(rowData)) return rowData.flags.includes(currentFlag) ?? false;
  else return false;
};
